import { TeamEventTypes } from '../models/team-event-type';
import { Locales } from './locales';

export const TeamEventTypeLocalization = {
  [Locales.ru]: {
    [TeamEventTypes.training]: 'Тренировка',
    [TeamEventTypes.other]: 'Другое',
  },
  [Locales.en]: {
    [TeamEventTypes.training]: 'Training',
    [TeamEventTypes.other]: 'Other',
  }
};
